// modifer: styles/jss/nextjs-material-kit-pro/pages/componentsSections/basicsStyle
import { section, container, whiteColor } from 'styles/jss/original/base';

const basicsStyle = {
  section: {
    ...section,
    textAlign: 'right',
    padding: '0'
  },
  container,
  icons: {
    width: '17px',
    height: '17px',
    color: whiteColor
  },
  displayNone: {
    display: 'none'
  }
};

export default basicsStyle;
